import { c as _c } from "react/compiler-runtime";
import { NotFoundComponent } from "@website/widget-v2/not-found";
import { Header } from "@website/widget/header";
import { GetServerSideProps } from "next";
export default function Custom404() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><Header title={"\u0648\u06CC\u0644\u0627"} /><NotFoundComponent /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export const getServerSideProps: GetServerSideProps = async ({
  res
}) => {
  res.statusCode = 410;
  return {
    props: {}
  };
};